import { GlIcon } from '@gitlab/ui';
export default {
    name: 'NoteAttachment',
    components: {
        GlIcon
    },
    props: {
        attachment: {
            type: Object,
            required: true
        }
    }
};
